import React from "react"

// Move to gatsby-browser?
const GlobalContext = React.createContext(null)

export default GlobalContext
